import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import ptBr from '../locales/pt-br';
import store from '../store/store';

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { 'pt-br': ptBr},
    current: store.getters.locale
  }
})
